module.exports = __webpack_public_path__ + "static/scale-model-of-gainesville-florida-86f2735c596075331b2b267f2e856dde.png";